import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ModalService } from 'src/app/shared/services/modal.service';
import { CLOSE_SESSION } from 'src/app/util/constantes-mensajes';
import { AuthService } from '../../auth/auth.service';
import { HeaderService } from '../services/header/header.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent {
  faCaretDown = faCaretDown;
  @Input() title = "";
  @Input() isMobile = false;
  disabledLink = null;
  searchControl = new FormControl('');
  isLoading = false;


  constructor(private authService: AuthService, private modalService: ModalService, private headerService: HeaderService, private ngxUiLoaderService: NgxUiLoaderService) { }

  logout() {
    this.modalService.getConfirmacionModal({ message: CLOSE_SESSION, confirmTitle: "Aceptar" })
      .result.then((result) => {
        if (result)
          this.authService.logout();
      })
  }

  support() {
    this.modalService.getJiraIssueModal();
  }

  search() {
    const searchTerm = this.searchControl.value?.trim();
    if (searchTerm) {
      this.isLoading = true;
      this.ngxUiLoaderService.start('header');
      this.headerService.searchInfo(searchTerm).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.ngxUiLoaderService.stop('header');
          this.modalService.getSearchResponseModal(response);
        },
        error: (error) => {
          this.isLoading = false;
          this.ngxUiLoaderService.stop('header');
          this.modalService.getConfirmacionModal({ message: error.error ? error.error?.message : 'Error en la creación del soporte', confirmTitle: 'Cerrar', isError: true })
        },
      });
    }
  }
}
